import type { Resolver } from 'cpool-schemas';
import { z } from 'zod';

type Arguments = {
    divisionId?: string | null;
};

export const schemaMailHeaderFooterPart = z.object({
    mailContent: z.string(),
    mailHTMLContent: z.string(),
});

export const schemaTemplateResolver_GetMailHeaderFooter = z.object({
    footer: schemaMailHeaderFooterPart.nullable(),
    header: schemaMailHeaderFooterPart.nullable(),
});

export type MailHeaderFooterPart = z.infer<typeof schemaMailHeaderFooterPart>;

export type SchemaTemplateResolver_GetMailHeaderFooter = z.infer<typeof schemaTemplateResolver_GetMailHeaderFooter>;

export type TemplateResolver_GetMailHeaderFooter = Resolver<Arguments, SchemaTemplateResolver_GetMailHeaderFooter>;
